
import mutations from '../../general/mutations';
import currentMutations from './mutations';
import { DataService } from '../../../../src/config/dataService/dataService';


const state = () => ({
    list: [],
    currentPartner: {},
    loading: false,
    message: '',
});
// declare actions
const actions = {

    async getAllPartners({ commit }) {
        const payload = {
            loginID: "awsat_web_dev",
            password:"vBwk7#R3RPdq&NGL"
        }
        try {
            await commit('axiosStart');
            const response = await DataService.get(`/Partner/GetAllPartners`,payload);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                await commit('SET_PARTNERS', response.data.data);
                return response.data.data
            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async addPartner({ commit }, partner) {
        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Partner/AddPartner`, partner);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token

            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async editPartner({ commit }, partner) {

        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Partner/UpdatePartner`, partner);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token

            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async changePartnerStatus({ commit },partnerId) {
        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Partner/ChangePartnerStatus`,{},{
                id:partnerId
            });
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    
    async setPartners({ commit }, partners) {
        try {
            await commit('SET_PARTNERS', partners);
            return true
        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    
    async storeCurrentPartnerToView({ commit },partner) {
        await commit('axiosStart');
        await commit('SET_CURRENT_PARTNER',partner);
        await commit('axiosSuccess');
        return true
	},

    


};

export default {
    namespaced: false,
    state,
    actions,
    mutations: { ...currentMutations, ...mutations }
};
